import { useEffect, useRef, useState } from "react";
import * as yup from "yup";
import Common from "../../../helper/common";
import { respEnum, IntMin, IntMax } from "../../../constants/appConstant";
import { Formik } from "formik";
import { Icon } from "@iconify/react";
import {
    FormikInput,
    FormikSearchSelect,
} from "../../../components/formik-components";
import { Button } from "../../../components/ui/button";

import {
    Dialog,
    DialogClose,
    DialogContent,
    DialogFooter,
    DialogHeader,
    DialogTitle,
    DialogTrigger,
} from "../../../components/ui/dialog";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";

const FormikInitialValues = {
  amount: null,
  start: null,
  end: null,
  sportId: null,
};

const formikValidation = yup.object({
    amount: yup.number().required("Amount is required"),
    sportId: yup.number().required("Sport is required"),
    amount: yup.number().min(IntMin).max(IntMax).required("Amount is required"),

    // start: yup
    //   .string()
    //   // .nullable()
    //   .matches(
    //     /^(0?[1-9]|1[0-2]):(00|30)\s?(AM|PM)$/i,
    //     "Time must be in HH:mm AM/PM format and minutes must be 00 or 30"
    //   )
    //   .required("Start Hr is required"),

    // end: yup
    //   .string()
    //   // .nullable()
    //   .matches(
    //     /^(0?[1-9]|1[0-2]):(00|30)\s?(AM|PM)$/i,
    //     "Time must be in HH:mm AM/PM format and minutes must be 00 or 30"
    //   )
    //   .required("End Hr is required"),
});

const AddOffPeak = ({ id, onClose, open, setOpen }) => {
  const formikRef = useRef();
  const dialogRef = useRef();
  const [sportNames, setSportNames] = useState([]);
  const [allQuickPatches, setAllQuickPatches] = useState([]);
  const navigate = useNavigate();
  const [isFormikInitialized, setIsFormikInitialized] = useState(false);

  // function checkTime(dateTime) {
  //   return dateTime === "01 Jan 1970, 12:00 AM";
  // }
  
  useEffect(() => {
    setIsFormikInitialized(open);
  }, [open]);

  useEffect(() => {
    if (open) {
      getSportNames();
      loadAllQuickPatches();
    }
  }, [open]);

  useEffect(() => {
    if (id) {
      getDataInfo();
    }
  }, [id]);
  const getSportNames = async () => {
    const response = await Common.ApiService.getInstance().request("GetClubSports");
    const data = [{ id: null, name: "Select" }, ...response.data];
    setSportNames(data);
  };

const loadAllQuickPatches = async () => {
  try {
    const response = await Common.ApiService.getInstance().request("QuickPatchList");

    if (response?.status === respEnum.Success) {
      setAllQuickPatches(response.data);
    } else {
      setAllQuickPatches([]);
    }
  } catch (err) {
    console.error("Failed to load quick patches:", err);
    setAllQuickPatches([]);
  }
};


  const validateMinutes = (timeStr) => {
    const [_, mm] = timeStr?.split(":") || [];
    return mm !== "00" && mm !== "30" && mm !== "59"; // invalid minutes
  };

  const checkOverlap = (start, end, sportId, currentId) => {
    const existing = allQuickPatches.filter(
      (x) => x.sportId === sportId && x.id !== currentId
    );

    const toMinutes = (timeStr) => {
      const [h, m] = timeStr.split(":").map(Number);
      return h * 60 + m;
    };

    const startMin = toMinutes(start);
    const endMin = toMinutes(end);

    return existing.some((x) => {
      const exStart = toMinutes(x.start);
      const exEnd = toMinutes(x.end);
      return !(endMin <= exStart || startMin >= exEnd);
    });
  };


  const onSubmitData = async (d, action) => {
    let data = {
      ...d,
      id,
    };
 
    if (!data.start || !data.end) {
      toast.error("Start and End time are required");
      return;
    }

    if (data.start >= data.end) {
      toast.error("End Time must be greater");
      return;
    }
    if (validateMinutes(data.start)) {
      toast.error("Start time must have minutes 00 , 30 or 59");
      return;
    }

    if (validateMinutes(data.end)) {
      toast.error("End time must have minutes 00 , 30 or 59");
      return;
    }

    // --- Overlap Validation ---
    if (checkOverlap(data.start, data.end, data.sportId, data.id)) {
      toast.error("This time range overlaps with an existing record");
      return;
    }


        let response = await Common.ApiService.getInstance().request(
            "AddUpdateQuickPatch",
            data,
            "POST"
        );

        action.setSubmitting(false);
        if (response.status === respEnum.Success) {
            onClose(response.data);
            setOpen(false);
            if (!onClose) {
                navigate("/app/offpeaks", { replace: true });
            }
        }
    };

    const getDataInfo = async () => {
      let response = await Common.ApiService.getInstance().request(
      `GetQuickPatches?id=${id}`
    );
      if (response.status === respEnum.Success && response.data.length > 0) {
          const item = response.data[0];
    // console.log(item);

        formikRef.current.setValues({
            ...item,
        });
      }
    };
  return (
    <div>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogTrigger asChild>
          <Button
            size="sm"
            variant="primary"
            className="flex items-center gap-2"
          >
            <Icon icon="heroicons:plus-20-solid" className="h-4 w-4" />
            Add
          </Button>
        </DialogTrigger>
        <DialogContent ref={dialogRef}>
          <DialogHeader>
            <DialogTitle className="text-base font-medium ">
              {!id ? "Add" : "Update"} Off Peak Pricing
            </DialogTitle>
          </DialogHeader>

                    <div className="text-sm text-default-500  space-y-2 max-h-[450px] overflow-y-auto pr-2">
                        <Formik
                            innerRef={formikRef}
                            onSubmit={onSubmitData}
                            initialValues={FormikInitialValues}
                            validationSchema={formikValidation}
                            validateOnChange={false}
                            validateOnBlur={false}
                        >
                            {(formikProps) => (
                                <div className="md:grid md:grid-cols-1 gap-6 mt-6 space-y-6 md:space-y-0">
                                    <div className="col-span-1">
                                        <div className="md:grid md:grid-cols-1  gap-6 mt-6 space-y-6 md:space-y-0">
                                            <div className="flex flex-col gap-2">
                                                <FormikSearchSelect
                                                    formikProps={formikProps}
                                                    name={"sportId"}
                                                    placeholder={"Select"}
                                                    label={"Sport"}
                                                    data={sportNames}
                                                />
                                            </div>

                                            <div className="flex flex-col gap-2">
                                                <FormikInput
                                                    formikProps={formikProps}
                                                    name={"amount"}
                                                    label={"Amount"}
                                                    placeholder={"Amount"}
                                                // maxLength="50"
                                                />
                                            </div>

                                            <div className="flex flex-col gap-2">
                                                <FormikInput
                                                    formikProps={formikProps}
                                                    type={"time"}
                                                    name={"start"}
                                                    label={"Start Time"}
                                                />
                                            </div>

                                            <div className="flex flex-col gap-2">
                                                <FormikInput
                                                    formikProps={formikProps}
                                                    type={"time"}
                                                    name={"end"}
                                                    label={"End Time"}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </Formik>
                    </div>
                    <DialogFooter className="mt-8 gap-2">
                        <DialogClose asChild>
                            <Button type="button" variant="outline">
                                Close
                            </Button>
                        </DialogClose>

                        {isFormikInitialized && formikRef.current && (
                            <Button
                                type="button"
                                onClick={(e) => {
                                    e.preventDefault();
                                    formikRef.current?.handleSubmit();
                                }}
                            >
                                {formikRef.current.isSubmitting
                                    ? "Saving..."
                                    : !id
                                        ? "Add"
                                        : "Update"}
                            </Button>
                        )}
                    </DialogFooter>
                </DialogContent>
            </Dialog>
        </div>
    );
};

export default AddOffPeak;
